import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { DropDownsModule } from '@progress/kendo-angular-dropdowns'
import { GridModule } from '@progress/kendo-angular-grid'
import { IndicatorsModule } from '@progress/kendo-angular-indicators'
import { FormFieldModule, InputsModule } from '@progress/kendo-angular-inputs'
import { LabelModule } from '@progress/kendo-angular-label'
import { LayoutModule } from '@progress/kendo-angular-layout'
import { PagerModule } from '@progress/kendo-angular-pager'

import {
  BadgeComponent,
  BannerComponent,
  BreadcrumbComponent,
  BreadcrumbListComponent,
  ButtonComponent,
  ErrorComponent,
  IconComponent,
  InputComponent,
  LinkComponent,
  MessageComponent,
  SelectComponent,
  TypographyComponent,
  SearchInputComponent,
} from '@hyperkit'

import { APIKeyDialogComponent } from '../account/components/api-keys/api-key-dialog/api-key-dialog.component'
import { ApiKeysComponent } from '../account/components/api-keys/api-keys.component'
import { DeleteUserDialogComponent } from '../account/components/manage-users/delete-user-dialog/delete-user-dialog.component'
import { EditUserDialogComponent } from '../account/components/manage-users/edit-user-dialog/edit-user-dialog.component'
import { NewUserDialogComponent } from '../account/components/manage-users/new-user-dialog/new-user-dialog.component'
import { SharedModule } from '../shared/shared.module'

import { CompanySettingsComponent } from './components/company-settings/cs.component'
import { DeleteEnvironmentDialogComponent } from './components/environment/delete-environment-dialog/delete-environment-dialog.component'
import { EditEnvironmentDialogComponent } from './components/environment/edit-environment-dialog/edit-environment-dialog.component'
import { EnvironmentComponent } from './components/environment/environment.component'
import { NewEnvironmentDialogComponent } from './components/environment/new-environment-dialog/new-environment-dialog.component'
import { ToolComponent } from './components/environment/tool/tool.component'
import { MyFavoritesComponent } from './components/favorites/favorites.component'
import { ManageUsersComponent } from './components/manage-users/mu.component'
import { MyAccountComponent } from './components/my/my.component'
import { SettingsComponent } from './settings.component'
import { SettingsRoutes } from './settings.routing'

@NgModule({
  declarations: [
    MyAccountComponent,
    SettingsComponent,
    MyFavoritesComponent,
    ApiKeysComponent,
    CompanySettingsComponent,
    ManageUsersComponent,
    EnvironmentComponent,
    NewEnvironmentDialogComponent,
    EditEnvironmentDialogComponent,
    DeleteEnvironmentDialogComponent,
    ToolComponent,
    APIKeyDialogComponent,
    NewUserDialogComponent,
    EditUserDialogComponent,
    DeleteUserDialogComponent,
  ],
  providers: [],
  imports: [
    InputComponent,
    ErrorComponent,
    SelectComponent,
    MessageComponent,
    BannerComponent,
    BreadcrumbListComponent,
    SearchInputComponent,
    BreadcrumbComponent,
    TypographyComponent,
    IconComponent,
    LinkComponent,
    BadgeComponent,
    ButtonComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    LayoutModule,
    PagerModule,
    DropDownsModule,
    FormFieldModule,
    InputsModule,
    LabelModule,
    IndicatorsModule,
    RouterModule.forChild(SettingsRoutes),
    SharedModule,
    TypographyComponent,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SettingsModule {}
